import { useState } from "react";

export default function useEventDialogs() {
  const [createEventOpen, setCreateEventOpen] = useState(false);
  const [createShiftOpen, setCreateShiftOpen] = useState(false);
  const [createJobOpen, setCreateJobOpen] = useState(false);
  const [lockDialogOpen, setLockDialogOpen] = useState(false);

  const [editingEvent, setEditingEvent] = useState(null);
  const [editingShift, setEditingShift] = useState(null);
  const [editingJob, setEditingJob] = useState(null);

  const closeEventDialog = () => {
    setCreateEventOpen(false);
    setEditingEvent(null);
  };

  return {
    // open flags
    createEventOpen,
    createShiftOpen,
    createJobOpen,
    lockDialogOpen,

    // setters
    setCreateEventOpen,
    setCreateShiftOpen,
    setCreateJobOpen,
    setLockDialogOpen,

    // editing
    editingEvent,
    editingShift,
    editingJob,

    setEditingEvent,
    setEditingShift,
    setEditingJob,

    closeEventDialog,
  };
}
